module.exports = __webpack_public_path__ + "1cd3a1d782e85ba37677c1a2099bc002.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/hipster2x.png
// module id = 334
// module chunks = 0